/* global angular, _ */

var ngModule = angular.module('trends');

/* Proivdes an interface to the current user's email alerts */
ngModule.factory('EmailAlertManagerFactory', ['Api', 'Monitor', function (Api, Monitor) {
    /* Global data */
    var alerts = {};
    var loadStatus = {};
    var frequencies = null;
    var defaultFrequency = null;

    /* Initialise frequencies */
    Api.cachedRequest(Api.alert_frequency, 'getList').then(function (data) {
        frequencies = _.filter(data, function(val) { return val.name !== 'disabled'; });
        defaultFrequency = _.find(frequencies, 'name', 'weekly');
    });

    /* Manager object representing the user's email alerts of the specific type */
    var EmailAlertManager = function (type) {
        /* Preload all alert of the current type */
        this.preloadAlerts = function () {
            return loadAlerts().promise;
        };

        /* Set an alert for the given id, with the specified fields */
        this.setAlert = function (id, fields) {
            var params = angular.copy(fields);
            params[idFieldName] = id;

            return Api.alerts[type].post(params).then(function (newAlert) {
                alerts[type][id] = newAlert.pk;
            });
        };

        /* Remove the alert for the specified id (if it exists) */
        this.removeAlert = function (id) {
            var params = {};
            params[idFieldName] = id;

            // Get the alert object by target id, then remove
            return Api.alerts[type].remove(params).then(function () {
                delete alerts[type][id];
            });
        };

        /* Returns true if set, false if unset, and null if specified alert is loading */
        this.alertIsSet = function (id) {
            var monitor = loadAlerts(id);

            if (monitor.resolved) {
                var typeAlerts = alerts[type];
                return !!(typeAlerts && typeAlerts[id]);
            }

            return null;
        };

        /* Returns the allowed alert frequencies */
        this.frequencies = function () {
            return frequencies;
        };

        /* Return the default alert frequency */
        this.defaultFrequency = function () {
            return defaultFrequency;
        };

        /* Name of field on the alert model specifying alert subject 
           e.g. id of hvt or item */
        var idFieldName = type + '_id';

        /* Load alerts. If id is specified, the single alert will be loaded.
           If id is null, all alerts of the current type are loaded.
           Returns a monitor. */
        var loadAlerts = function(id) {
            // Return existing promise if already loading
            var loadingStatus = getLoadStatus(id);
            if (loadingStatus) {
                return loadingStatus;
            }

            // Set id override if specified
            var params = {};
            if (id) {
                params[idFieldName] = id;
            }

            if (!alerts[type]) {
                alerts[type] = {};
            }

            // Make api request
            var promise = Api.alerts[type].getList(params).then(function (data) {
                _.reduce(data, function (result, alert_val) {
                    result[getId(alert_val)] = alert_val.pk;
                    return result;
                }, alerts[type]);
            });

            // Create monitor
            var monitor = new Monitor();
            monitor.watch(promise);
            loadStatus[ [type, id] ] = monitor;

            return monitor;
        };

        /* Returns the monitor associated with the load request for the given alert
           If id is null or the specific alert is not currently being loaded, this will return
           the monitor associated with a preload request. If there is no preload request,
           this returns undefined */
        var getLoadStatus = function (id) {
            var stat = loadStatus[ [type, id] ];
            if (stat === undefined && id) {
                stat = loadStatus[ [ type, undefined ] ];
            }
            return stat;
        };

        /* Extract id field from object. Fakes an id valoue for newsletter (has not associated id) */
        var getId = function (val) {
            if (type === 'newsletter') {
                return 0;
            } else {
                return val[idFieldName];
            }
        };
    };

    return EmailAlertManager;
}]);
